import ReactDOM from 'react-dom'
import App from './components/App'
import './DayJs'
import './Sentry'
import onUnhandledPromiseRejection from './ygdrasil/libs/onUnhandledPromiseRejection'

ReactDOM.render(<App />, document.getElementById('root'))

window.addEventListener('unhandledrejection', ({ promise, reason: error }) => onUnhandledPromiseRejection(error))
